/**
 * MarvaChat stylesheet payloads — extracted verbatim from tracking-sdk.js.
 * Two <style> bodies injected by MarvaChat.injectStyles() /
 * injectAfterHoursStyles(). Plain CSS, no interpolations.
 */
'use strict';

const CHAT_WIDGET_CSS = `
                /* ========== FLOATING INPUT BAR ========== */

                /* Container - centered at bottom, draggable */
                .marva-chat {
                    position: fixed !important;
                    bottom: 24px !important;
                    left: 50% !important;
                    transform: translateX(-50%) !important;
                    z-index: 2147483647 !important;
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
                    font-size: 14px !important;
                }
                .marva-chat.dragged,
                .marva-chat.dragging {
                    transform: none !important;
                }
                .marva-chat.expanded {
                    z-index: 2147483648 !important;
                }
                .marva-chat * {
                    box-sizing: border-box !important;
                }

                /* The input pill - this IS the bubble, but with an input inside */
                .marva-chat-bubble {
                    background: white !important;
                    color: rgba(0, 0, 0, 0.8) !important;
                    border-radius: 28px !important;
                    padding: 6px 6px 6px 20px !important;
                    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.08) !important;
                    border: 1px solid rgba(0, 0, 0, 0.08) !important;
                    display: flex !important;
                    align-items: center !important;
                    gap: 8px !important;
                    transition: all 0.2s ease !important;
                    min-width: 280px !important;
                    cursor: text !important;
                }
                .marva-chat-bubble:hover {
                    box-shadow: 0 6px 32px rgba(0, 0, 0, 0.15), 0 2px 8px rgba(0, 0, 0, 0.1) !important;
                }
                .marva-chat.dragging .marva-chat-bubble {
                    cursor: grabbing !important;
                    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.2) !important;
                }

                /* Input inside the bubble */
                .marva-bubble-input {
                    flex: 1 !important;
                    border: none !important;
                    background: transparent !important;
                    font-size: 15px !important;
                    color: rgba(0, 0, 0, 0.85) !important;
                    outline: none !important;
                    box-shadow: none !important;
                    -webkit-appearance: none !important;
                    -moz-appearance: none !important;
                    appearance: none !important;
                    padding: 10px 0 !important;
                    font-family: inherit !important;
                    min-width: 0 !important;
                }
                .marva-bubble-input::placeholder {
                    color: rgba(0, 0, 0, 0.4) !important;
                }
                .marva-bubble-input:focus {
                    outline: none !important;
                    box-shadow: none !important;
                    border: none !important;
                }
                .marva-bubble-input:focus-visible {
                    outline: none !important;
                    box-shadow: none !important;
                }

                /* Send button in bubble */
                .marva-bubble-send {
                    background: rgba(0, 0, 0, 0.85) !important;
                    color: white !important;
                    border: none !important;
                    border-radius: 50% !important;
                    width: 36px !important;
                    height: 36px !important;
                    cursor: pointer !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    font-size: 16px !important;
                    flex-shrink: 0 !important;
                    transition: all 0.15s ease !important;
                    opacity: 0.3 !important;
                }
                .marva-bubble-send.active {
                    opacity: 1 !important;
                }
                .marva-bubble-send.active:hover {
                    background: black !important;
                    transform: scale(1.05) !important;
                }

                /* Compare button in bubble */
                .marva-compare-btn {
                    background: transparent !important;
                    color: rgba(0, 0, 0, 0.5) !important;
                    border: none !important;
                    border-radius: 50% !important;
                    width: 32px !important;
                    height: 32px !important;
                    cursor: pointer !important;
                    display: none !important;
                    align-items: center !important;
                    justify-content: center !important;
                    flex-shrink: 0 !important;
                    transition: all 0.15s ease !important;
                    padding: 0 !important;
                }
                .marva-compare-btn.visible {
                    display: flex !important;
                }
                .marva-compare-btn:hover {
                    background: rgba(0, 0, 0, 0.08) !important;
                    color: rgba(0, 0, 0, 0.8) !important;
                }
                .marva-compare-btn svg {
                    width: 16px !important;
                    height: 16px !important;
                }

                /* Comparison picker modal — After Hours (gold selection, sage check) */
                .marva-comparison-picker-overlay {
                    position: fixed !important;
                    top: 0 !important;
                    left: 0 !important;
                    right: 0 !important;
                    bottom: 0 !important;
                    background: rgba(20, 16, 12, 0.46) !important;
                    backdrop-filter: blur(3px) !important;
                    -webkit-backdrop-filter: blur(3px) !important;
                    z-index: 2147483648 !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    padding: 20px !important;
                }
                .marva-comparison-picker {
                    background: var(--bg) !important;
                    border: 1px solid var(--line) !important;
                    border-radius: 20px !important;
                    padding: 18px !important;
                    max-width: 400px !important;
                    width: 100% !important;
                    max-height: 80vh !important;
                    overflow-y: auto !important;
                    color: var(--ink) !important;
                    box-shadow: 0 30px 70px -28px rgba(0,0,0,.6), 0 8px 24px rgba(0,0,0,.18) !important;
                }
                .marva-picker-head {
                    display: flex !important;
                    align-items: flex-start !important;
                    gap: 11px !important;
                    margin-bottom: 14px !important;
                }
                .marva-comparison-picker .w-orb {
                    width: 26px !important;
                    height: 26px !important;
                    margin-top: 1px !important;
                }
                .marva-comparison-picker h3 {
                    margin: 0 !important;
                    font-family: 'Fraunces', serif !important;
                    font-size: 18px !important;
                    font-weight: 500 !important;
                    color: var(--ink) !important;
                    line-height: 1.1 !important;
                }
                .marva-comparison-picker p {
                    margin: 5px 0 0 0 !important;
                    font-size: 12.5px !important;
                    line-height: 1.45 !important;
                    color: var(--ink-soft) !important;
                }
                .marva-comparison-picker p b {
                    color: var(--gold-ink) !important;
                    font-weight: 600 !important;
                }
                .marva-comparison-picker-products {
                    display: flex !important;
                    flex-direction: column !important;
                    gap: 8px !important;
                    margin-bottom: 16px !important;
                }
                .marva-picker-product {
                    display: flex !important;
                    align-items: center !important;
                    gap: 12px !important;
                    padding: 9px 11px !important;
                    border: 1px solid var(--line) !important;
                    border-radius: 13px !important;
                    background: var(--surface) !important;
                    cursor: pointer !important;
                    transition: all 0.14s ease !important;
                }
                .marva-picker-product:hover {
                    border-color: var(--gold-line) !important;
                }
                .marva-picker-product.selected {
                    border-color: var(--gold-line) !important;
                    background: var(--gold-tint) !important;
                }
                .marva-picker-product img {
                    width: 44px !important;
                    height: 44px !important;
                    object-fit: cover !important;
                    border-radius: 9px !important;
                    background: var(--raise) !important;
                }
                .marva-picker-product-info {
                    flex: 1 !important;
                    min-width: 0 !important;
                }
                .marva-picker-product-title {
                    font-size: 13px !important;
                    font-weight: 600 !important;
                    color: var(--ink) !important;
                    line-height: 1.3 !important;
                    white-space: nowrap !important;
                    overflow: hidden !important;
                    text-overflow: ellipsis !important;
                }
                .marva-picker-product-price {
                    font-size: 11px !important;
                    color: var(--ink-faint) !important;
                    margin-top: 2px !important;
                }
                .marva-picker-checkbox {
                    width: 22px !important;
                    height: 22px !important;
                    border: 1.5px solid var(--line) !important;
                    border-radius: 7px !important;
                    background: var(--bg) !important;
                    color: transparent !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    flex-shrink: 0 !important;
                    font-size: 13px !important;
                    font-weight: 700 !important;
                    transition: all 0.14s ease !important;
                }
                .marva-picker-product.selected .marva-picker-checkbox {
                    background: var(--sage) !important;
                    border-color: transparent !important;
                    color: #1b2a1f !important;
                }
                .marva-comparison-picker-actions {
                    display: flex !important;
                    gap: 10px !important;
                    justify-content: flex-end !important;
                }
                .marva-picker-btn {
                    padding: 10px 18px !important;
                    border-radius: 99px !important;
                    font-family: 'Hanken Grotesk', sans-serif !important;
                    font-size: 13px !important;
                    font-weight: 500 !important;
                    cursor: pointer !important;
                    transition: all 0.15s ease !important;
                    border: none !important;
                }
                .marva-picker-btn-cancel {
                    background: transparent !important;
                    color: var(--ink) !important;
                    border: 1px solid var(--line) !important;
                }
                .marva-picker-btn-cancel:hover {
                    border-color: var(--gold-line) !important;
                }
                .marva-picker-btn-compare {
                    background: linear-gradient(180deg, var(--gold-soft), var(--gold)) !important;
                    color: #241d0f !important;
                }
                .mv-light .marva-picker-btn-compare {
                    color: #fff !important;
                }
                .marva-picker-btn-compare:disabled {
                    opacity: 0.5 !important;
                    cursor: not-allowed !important;
                }

                /* Drag handle */
                .marva-drag-handle {
                    width: 20px !important;
                    height: 36px !important;
                    cursor: grab !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    color: rgba(0, 0, 0, 0.2) !important;
                    flex-shrink: 0 !important;
                    margin-left: -8px !important;
                }
                .marva-drag-handle:hover {
                    color: rgba(0, 0, 0, 0.4) !important;
                }
                .marva-chat.dragging .marva-drag-handle {
                    cursor: grabbing !important;
                }

                /* ========== FULL-SCREEN CHAT MODAL ========== */

                div.marva-chat-overlay {
                    all: initial !important;
                    position: fixed !important;
                    top: 0 !important;
                    left: 0 !important;
                    right: 0 !important;
                    bottom: 0 !important;
                    width: 100vw !important;
                    height: 100vh !important;
                    background: rgba(255, 255, 255, 0.6) !important;
                    backdrop-filter: blur(12px) saturate(150%) !important;
                    -webkit-backdrop-filter: blur(12px) saturate(150%) !important;
                    z-index: 2147483645 !important;
                    opacity: 0 !important;
                    visibility: hidden !important;
                    pointer-events: none !important;
                    transition: opacity 0.3s ease, visibility 0.3s ease !important;
                    display: block !important;
                }
                div.marva-chat-overlay.visible {
                    opacity: 1 !important;
                    visibility: visible !important;
                    pointer-events: auto !important;
                }

                /* Chat window - appears behind/around the input */
                .marva-chat-window {
                    position: fixed !important;
                    top: 0 !important;
                    left: 0 !important;
                    right: 0 !important;
                    bottom: 80px !important;
                    background: transparent !important;
                    z-index: 2147483646 !important;
                    display: flex !important;
                    flex-direction: column !important;
                    opacity: 0 !important;
                    visibility: hidden !important;
                    transition: all 0.25s ease !important;
                    pointer-events: none !important;
                }
                .marva-chat-window.open {
                    opacity: 1 !important;
                    visibility: visible !important;
                    pointer-events: auto !important;
                }

                /* Close button - top right */
                .marva-chat-close {
                    position: fixed !important;
                    top: 20px !important;
                    right: 20px !important;
                    background: rgba(0, 0, 0, 0.05) !important;
                    border: none !important;
                    font-size: 24px !important;
                    color: rgba(0, 0, 0, 0.4) !important;
                    cursor: pointer !important;
                    padding: 0 !important;
                    width: 44px !important;
                    height: 44px !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    border-radius: 50% !important;
                    transition: all 0.15s ease !important;
                    z-index: 2147483649 !important;
                    opacity: 0 !important;
                    visibility: hidden !important;
                }
                .marva-chat-window.open + .marva-chat-close,
                .marva-chat-close.visible {
                    opacity: 1 !important;
                    visibility: visible !important;
                }
                .marva-chat-close:hover {
                    background: rgba(0, 0, 0, 0.1) !important;
                    color: rgba(0, 0, 0, 0.7) !important;
                }

                /* Messages area */
                .marva-chat-messages {
                    flex: 1 !important;
                    overflow-y: auto !important;
                    padding: 80px 24px 24px !important;
                    display: flex !important;
                    flex-direction: column !important;
                    gap: 16px !important;
                    max-width: 720px !important;
                    margin: 0 auto !important;
                    width: 100% !important;
                }

                /* Message bubbles */
                .marva-msg {
                    max-width: 85% !important;
                    padding: 14px 18px !important;
                    line-height: 1.5 !important;
                    word-wrap: break-word !important;
                    font-size: 15px !important;
                }
                .marva-msg.user {
                    background: rgba(0, 0, 0, 0.9) !important;
                    color: white !important;
                    align-self: flex-end !important;
                    border-radius: 20px 20px 4px 20px !important;
                }
                .marva-msg.agent {
                    background: rgba(0, 0, 0, 0.05) !important;
                    color: rgba(0, 0, 0, 0.85) !important;
                    align-self: flex-start !important;
                    border-radius: 20px 20px 20px 4px !important;
                }

                /* Products in messages */
                .marva-products {
                    display: flex !important;
                    flex-direction: column !important;
                    gap: 8px !important;
                    margin-top: 12px !important;
                }
                .marva-product-card {
                    display: flex !important;
                    gap: 12px !important;
                    padding: 12px !important;
                    background: white !important;
                    border-radius: 12px !important;
                    cursor: pointer !important;
                    transition: all 0.15s ease !important;
                    border: 1px solid rgba(0,0,0,0.06) !important;
                }
                .marva-product-card:hover {
                    border-color: rgba(0,0,0,0.12) !important;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.06) !important;
                }
                .marva-product-card img {
                    width: 56px !important;
                    height: 56px !important;
                    object-fit: cover !important;
                    border-radius: 8px !important;
                    flex-shrink: 0 !important;
                }
                .marva-product-info {
                    flex: 1 !important;
                    min-width: 0 !important;
                }
                .marva-product-title {
                    font-weight: 500 !important;
                    font-size: 14px !important;
                    color: rgba(0, 0, 0, 0.85) !important;
                    margin-bottom: 2px !important;
                    overflow: hidden !important;
                    text-overflow: ellipsis !important;
                    white-space: nowrap !important;
                }
                .marva-product-price {
                    font-size: 13px !important;
                    color: rgba(0, 0, 0, 0.5) !important;
                    font-weight: 500 !important;
                }
                .marva-product-compare-price {
                    font-size: 11px !important;
                    color: rgba(0, 0, 0, 0.35) !important;
                    text-decoration: line-through !important;
                }
                .marva-product-actions {
                    display: flex !important;
                    gap: 6px !important;
                    margin-top: 8px !important;
                }
                .marva-product-actions button {
                    flex: 1 !important;
                    padding: 6px 10px !important;
                    font-size: 11px !important;
                    font-weight: 500 !important;
                    border-radius: 6px !important;
                    border: 1px solid rgba(0, 0, 0, 0.12) !important;
                    background: white !important;
                    cursor: pointer !important;
                    transition: all 0.15s ease !important;
                }
                .marva-product-actions button:hover {
                    background: rgba(0, 0, 0, 0.03) !important;
                    border-color: rgba(0, 0, 0, 0.2) !important;
                }
                .marva-product-view {
                    background: #1a1a1a !important;
                    color: white !important;
                    border: none !important;
                }
                .marva-product-view:hover {
                    background: #333 !important;
                }
                .marva-product-compare {
                    color: rgba(0, 0, 0, 0.6) !important;
                }

                /* Agent cards (unified card system) */
                .marva-agent-cards {
                    display: flex !important;
                    flex-direction: column !important;
                    gap: 8px !important;
                    margin-top: 8px !important;
                }
                /* Grid layout for multiple product cards (side by side) */
                .marva-cards-grid {
                    display: grid !important;
                    grid-template-columns: repeat(3, 1fr) !important;
                    gap: 8px !important;
                }
                .marva-cards-grid .marva-card {
                    max-width: none !important;
                }
                .marva-cards-grid .marva-card-image {
                    height: 80px !important;
                }
                .marva-cards-grid .marva-card-body {
                    padding: 8px !important;
                }
                .marva-cards-grid .marva-card-title {
                    font-size: 11px !important;
                    display: -webkit-box !important;
                    -webkit-line-clamp: 2 !important;
                    -webkit-box-orient: vertical !important;
                    overflow: hidden !important;
                }
                .marva-cards-grid .marva-card-price {
                    font-size: 13px !important;
                }
                .marva-cards-grid .marva-card-btn {
                    font-size: 11px !important;
                    padding: 6px 10px !important;
                }
                .marva-card {
                    background: white !important;
                    border: 1px solid rgba(0,0,0,0.08) !important;
                    border-radius: 12px !important;
                    overflow: hidden !important;
                    max-width: 280px !important;
                }
                .marva-card-image {
                    width: 100% !important;
                    height: 150px !important;
                    object-fit: cover !important;
                    display: block !important;
                }
                .marva-card-body {
                    padding: 12px !important;
                }
                .marva-card-body.centered {
                    text-align: center !important;
                }
                .marva-card-title {
                    font-size: 14px !important;
                    font-weight: 600 !important;
                    color: #1a1a1a !important;
                    margin-bottom: 6px !important;
                    line-height: 1.3 !important;
                    text-decoration: none !important;
                    display: block !important;
                }
                .marva-card-title:hover {
                    color: #667eea !important;
                }
                .marva-card-variant {
                    font-size: 12px !important;
                    color: #666 !important;
                    margin-bottom: 6px !important;
                }
                .marva-card-price {
                    font-size: 16px !important;
                    font-weight: 600 !important;
                    color: #1a1a1a !important;
                    margin-bottom: 10px !important;
                }
                .marva-card-price-old {
                    font-size: 12px !important;
                    color: #999 !important;
                    text-decoration: line-through !important;
                    margin-left: 6px !important;
                }
                .marva-card-btn {
                    display: inline-block !important;
                    background: #667eea !important;
                    color: white !important;
                    padding: 8px 16px !important;
                    border-radius: 6px !important;
                    text-decoration: none !important;
                    font-size: 13px !important;
                    font-weight: 500 !important;
                }
                .marva-card-btn:hover {
                    background: #5a6fd8 !important;
                }
                .marva-card-btn-full {
                    display: block !important;
                    text-align: center !important;
                    margin-top: 12px !important;
                }
                .marva-card-actions {
                    display: flex !important;
                    align-items: center !important;
                    gap: 8px !important;
                    flex-wrap: wrap !important;
                }
                .marva-card-add {
                    border: none !important;
                    cursor: pointer !important;
                    font-family: inherit !important;
                }
                .marva-card-add:disabled {
                    cursor: default !important;
                    opacity: 0.85 !important;
                }
                .marva-card-add.marva-card-added {
                    background: #16a34a !important;
                }
                .marva-card-btn-ghost {
                    background: transparent !important;
                    color: #667eea !important;
                    border: 1px solid #d6d9f5 !important;
                    padding: 7px 14px !important;
                }
                .marva-card-btn-ghost:hover {
                    background: #f5f6ff !important;
                }
                .marva-card-badge-success {
                    background: #16a34a !important;
                    color: white !important;
                    padding: 8px !important;
                    text-align: center !important;
                    font-size: 12px !important;
                    font-weight: 700 !important;
                    text-transform: uppercase !important;
                    letter-spacing: 1px !important;
                }
                .marva-card-pricing {
                    border-top: 1px solid rgba(0,0,0,0.08) !important;
                    padding-top: 8px !important;
                    margin-top: 8px !important;
                }
                .marva-card-was {
                    font-size: 12px !important;
                    color: #999 !important;
                }
                .marva-card-was .line-through {
                    text-decoration: line-through !important;
                }
                .marva-card-now {
                    font-size: 18px !important;
                    font-weight: 700 !important;
                    color: #1a1a1a !important;
                    margin: 4px 0 !important;
                }
                .marva-card-savings {
                    font-size: 13px !important;
                    color: #16a34a !important;
                    font-weight: 600 !important;
                }
                .marva-card-urgency {
                    font-size: 12px !important;
                    color: #ea580c !important;
                    margin-top: 8px !important;
                    font-weight: 500 !important;
                }
                .marva-card-comparison {
                    max-width: 320px !important;
                }
                .marva-comparison-grid {
                    display: flex !important;
                    gap: 8px !important;
                    padding: 8px !important;
                }
                .marva-comparison-item {
                    flex: 1 !important;
                    border: 1px solid rgba(0,0,0,0.08) !important;
                    border-radius: 8px !important;
                    padding: 8px !important;
                    text-align: center !important;
                    background: white !important;
                }
                .marva-comparison-item.highlighted {
                    border: 2px solid #667eea !important;
                }
                .marva-comparison-image {
                    width: 100% !important;
                    height: 80px !important;
                    object-fit: cover !important;
                    border-radius: 4px !important;
                    margin-bottom: 8px !important;
                }
                .marva-comparison-title {
                    font-size: 12px !important;
                    font-weight: 600 !important;
                    color: #1a1a1a !important;
                    text-decoration: none !important;
                    display: block !important;
                    margin-bottom: 4px !important;
                    line-height: 1.2 !important;
                    min-height: 28px !important;
                }
                .marva-comparison-price {
                    margin-bottom: 8px !important;
                    font-size: 14px !important;
                    font-weight: 600 !important;
                }
                .marva-comparison-btn {
                    display: inline-block !important;
                    background: rgba(0,0,0,0.05) !important;
                    color: #1a1a1a !important;
                    padding: 6px 12px !important;
                    border-radius: 4px !important;
                    text-decoration: none !important;
                    font-size: 11px !important;
                    font-weight: 500 !important;
                }
                .marva-comparison-btn:hover {
                    background: rgba(0,0,0,0.1) !important;
                }
                .marva-cart-header {
                    font-size: 14px !important;
                    font-weight: 600 !important;
                    color: #1a1a1a !important;
                    margin-bottom: 8px !important;
                }
                .marva-cart-items {
                    border-top: 2px solid rgba(0,0,0,0.08) !important;
                }
                .marva-cart-item {
                    display: flex !important;
                    gap: 8px !important;
                    padding: 8px 0 !important;
                    border-bottom: 1px solid rgba(0,0,0,0.08) !important;
                }
                .marva-cart-item-image {
                    width: 50px !important;
                    height: 50px !important;
                    object-fit: cover !important;
                    border-radius: 4px !important;
                    flex-shrink: 0 !important;
                }
                .marva-cart-item-info {
                    flex: 1 !important;
                    min-width: 0 !important;
                }
                .marva-cart-item-title {
                    font-size: 12px !important;
                    font-weight: 500 !important;
                    color: #1a1a1a !important;
                    white-space: nowrap !important;
                    overflow: hidden !important;
                    text-overflow: ellipsis !important;
                }
                .marva-cart-item-variant {
                    font-size: 11px !important;
                    color: #999 !important;
                }
                .marva-cart-item-qty {
                    font-size: 11px !important;
                    color: #666 !important;
                }
                .marva-cart-item-price {
                    font-size: 13px !important;
                    font-weight: 500 !important;
                    color: #1a1a1a !important;
                    flex-shrink: 0 !important;
                }
                .marva-cart-total {
                    display: flex !important;
                    justify-content: space-between !important;
                    padding-top: 10px !important;
                    margin-top: 4px !important;
                    font-size: 14px !important;
                    font-weight: 600 !important;
                    color: #1a1a1a !important;
                }
                .marva-cart-total-price {
                    font-weight: 700 !important;
                }

                /* Comparison card in chat */
                .marva-comparison-card {
                    background: var(--surface) !important;
                    border-radius: 16px !important;
                    padding: 16px !important;
                    box-shadow: 0 20px 44px -30px var(--glow) !important;
                    border: 1px solid var(--line) !important;
                    color: var(--ink) !important;
                    width: 100% !important;
                    max-width: 100% !important;
                    align-self: stretch !important;
                }
                .marva-comparison-card-header {
                    display: flex !important;
                    justify-content: space-between !important;
                    align-items: center !important;
                    margin-bottom: 12px !important;
                }
                .marva-comparison-card-title {
                    font-family: 'Fraunces', serif !important;
                    font-size: 15px !important;
                    font-weight: 500 !important;
                    color: var(--ink) !important;
                }
                .marva-comparison-card-close {
                    background: none !important;
                    border: none !important;
                    font-size: 18px !important;
                    color: var(--ink-faint) !important;
                    cursor: pointer !important;
                    padding: 4px !important;
                    line-height: 1 !important;
                }
                .marva-comparison-card-close:hover {
                    color: var(--ink) !important;
                }
                .marva-comparison-card-products {
                    display: grid !important;
                    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)) !important;
                    gap: 12px !important;
                    margin-bottom: 12px !important;
                }
                .marva-comparison-card-product {
                    background: var(--bg) !important;
                    border: 1px solid var(--line) !important;
                    border-radius: 13px !important;
                    padding: 11px !important;
                    position: relative !important;
                    display: flex !important;
                    flex-direction: column !important;
                    text-align: center !important;
                }
                .marva-comparison-card-product img {
                    width: 100% !important;
                    height: 96px !important;
                    object-fit: cover !important;
                    border-radius: 9px !important;
                    margin-bottom: 10px !important;
                    background: linear-gradient(135deg, var(--raise), var(--bg-2)) !important;
                }
                .marva-comparison-card-product-title {
                    font-size: 12.5px !important;
                    font-weight: 600 !important;
                    color: var(--ink) !important;
                    margin-bottom: 6px !important;
                    line-height: 1.3 !important;
                    overflow: hidden !important;
                    text-overflow: ellipsis !important;
                    white-space: nowrap !important;
                }
                .marva-comparison-card-product-price {
                    font-family: 'Fraunces', serif !important;
                    font-size: 15px !important;
                    font-weight: 600 !important;
                    color: var(--ink) !important;
                    margin-bottom: 10px !important;
                }
                .marva-comparison-card-product-price .sale {
                    color: var(--gold-ink) !important;
                }
                .marva-comparison-card-product-price .original {
                    text-decoration: line-through !important;
                    color: var(--ink-faint) !important;
                    font-size: 12px !important;
                    font-weight: 400 !important;
                    font-family: 'Hanken Grotesk', sans-serif !important;
                    margin-left: 6px !important;
                }
                .marva-comparison-card-product-remove {
                    position: absolute !important;
                    top: 6px !important;
                    right: 6px !important;
                    width: 22px !important;
                    height: 22px !important;
                    background: var(--surface) !important;
                    border: 1px solid var(--line) !important;
                    border-radius: 50% !important;
                    font-size: 14px !important;
                    color: var(--ink-faint) !important;
                    cursor: pointer !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12) !important;
                }
                .marva-comparison-card-product-remove:hover {
                    color: var(--ink) !important;
                    border-color: var(--gold-line) !important;
                }
                .marva-comparison-card-product-btn {
                    background: linear-gradient(180deg, var(--gold-soft), var(--gold)) !important;
                    color: #241d0f !important;
                    border: none !important;
                    border-radius: 99px !important;
                    padding: 8px 12px !important;
                    font-family: 'Hanken Grotesk', sans-serif !important;
                    font-size: 12px !important;
                    font-weight: 500 !important;
                    cursor: pointer !important;
                    margin-top: auto !important;
                    transition: all 0.15s ease !important;
                }
                .mv-light .marva-comparison-card-product-btn {
                    color: #fff !important;
                }
                .marva-comparison-card-product-btn.added {
                    background: linear-gradient(180deg, var(--sage-ink), var(--sage)) !important;
                }
                .marva-comparison-card-actions {
                    display: flex !important;
                    gap: 10px !important;
                    justify-content: center !important;
                    flex-wrap: wrap !important;
                }
                .marva-comparison-card-btn {
                    display: inline-flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    gap: 7px !important;
                    background: linear-gradient(180deg, var(--gold-soft), var(--gold)) !important;
                    color: #241d0f !important;
                    border: none !important;
                    border-radius: 99px !important;
                    padding: 10px 16px !important;
                    font-family: 'Hanken Grotesk', sans-serif !important;
                    font-size: 12.5px !important;
                    font-weight: 500 !important;
                    cursor: pointer !important;
                    transition: all 0.15s ease !important;
                }
                .mv-light .marva-comparison-card-btn {
                    color: #fff !important;
                }
                .marva-comparison-card-btn:hover {
                    transform: translateY(-1px) !important;
                }
                .marva-comparison-card-btn.secondary {
                    background: transparent !important;
                    color: var(--ink) !important;
                    border: 1px solid var(--line) !important;
                }
                .marva-comparison-card-btn.secondary:hover {
                    border-color: var(--gold-line) !important;
                    transform: none !important;
                }
                .marva-comparison-card-loading {
                    display: flex !important;
                    align-items: center !important;
                    gap: 8px !important;
                    font-size: 12px !important;
                    color: var(--ink-soft) !important;
                    margin-bottom: 12px !important;
                }
                .marva-comparison-card-differentiators {
                    display: flex !important;
                    flex-wrap: wrap !important;
                    gap: 7px !important;
                    margin-bottom: 12px !important;
                }
                .marva-comparison-card-diff {
                    display: inline-flex !important;
                    align-items: baseline !important;
                    gap: 6px !important;
                    background: var(--surface) !important;
                    border: 1px solid var(--line) !important;
                    border-radius: 99px !important;
                    padding: 6px 12px !important;
                    font-size: 11px !important;
                    color: var(--ink-faint) !important;
                }
                .marva-comparison-card-diff-winner {
                    font-size: 11.5px !important;
                    font-weight: 600 !important;
                    color: var(--gold-ink) !important;
                }
                .marva-comparison-card-empty {
                    text-align: center !important;
                    padding: 24px !important;
                    color: var(--ink-faint) !important;
                    font-size: 14px !important;
                }

                /* Suggested actions */
                .marva-suggested-actions {
                    display: flex !important;
                    flex-wrap: wrap !important;
                    gap: 8px !important;
                    margin-top: 12px !important;
                }
                .marva-chat-action {
                    display: inline-flex !important;
                    align-items: center !important;
                    gap: 6px !important;
                    background: white !important;
                    border: 1px solid rgba(0, 0, 0, 0.1) !important;
                    border-radius: 100px !important;
                    padding: 8px 14px !important;
                    font-size: 13px !important;
                    color: rgba(0, 0, 0, 0.7) !important;
                    cursor: pointer !important;
                    font-family: inherit !important;
                    transition: all 0.15s ease !important;
                }
                .marva-chat-action:hover {
                    background: rgba(0, 0, 0, 0.03) !important;
                    border-color: rgba(0, 0, 0, 0.2) !important;
                }
                .marva-chat-action svg {
                    flex-shrink: 0 !important;
                    opacity: 0.7 !important;
                }

                /* Typing indicator */
                .marva-typing {
                    display: flex !important;
                    gap: 4px !important;
                    padding: 14px 18px !important;
                    background: rgba(0, 0, 0, 0.05) !important;
                    border-radius: 20px 20px 20px 4px !important;
                    align-self: flex-start !important;
                }
                .marva-typing span {
                    width: 6px !important;
                    height: 6px !important;
                    background: rgba(0, 0, 0, 0.3) !important;
                    border-radius: 50% !important;
                    animation: marva-bounce 1.4s ease-in-out infinite !important;
                }
                .marva-typing span:nth-child(2) { animation-delay: 0.15s !important; }
                .marva-typing span:nth-child(3) { animation-delay: 0.3s !important; }
                @keyframes marva-bounce {
                    0%, 60%, 100% { transform: translateY(0); }
                    30% { transform: translateY(-3px); }
                }

                /* Legacy - hidden */
                .marva-chat-content { display: none !important; }
                .marva-chat-message { display: none !important; }
                .marva-chat-actions { display: none !important; }
                .marva-chat-header { display: none !important; }
                .marva-chat-input-area { display: none !important; }

                /* Proactive indicator - pulsing glow effect */
                .marva-chat-bubble.has-notification {
                    animation: marva-bounce 0.6s ease-out !important;
                }

                .marva-chat-bubble.has-notification::before {
                    content: '' !important;
                    position: absolute !important;
                    top: -4px !important;
                    right: -4px !important;
                    width: 12px !important;
                    height: 12px !important;
                    background: #22c55e !important;
                    border-radius: 50% !important;
                    border: 2px solid white !important;
                    animation: marva-pulse 2s ease-in-out infinite !important;
                }

                .marva-chat-bubble.has-notification::after {
                    content: '' !important;
                    position: absolute !important;
                    inset: -4px !important;
                    border-radius: 16px !important;
                    background: transparent !important;
                    box-shadow: 0 0 0 0 rgba(79, 70, 229, 0.4) !important;
                    animation: marva-glow 2s ease-in-out 3 !important;
                    pointer-events: none !important;
                }

                /* Message preview tooltip — After Hours (inherits tokens from the
                   themed launcher container the bubble sits inside) */
                .marva-message-preview {
                    position: absolute !important;
                    bottom: calc(100% + 12px) !important;
                    left: 50% !important;
                    transform: translateX(-50%) !important;
                    background: var(--surface) !important;
                    color: var(--ink) !important;
                    border: 1px solid var(--line) !important;
                    padding: 12px 16px !important;
                    border-radius: 14px !important;
                    box-shadow: 0 14px 38px -18px rgba(0, 0, 0, 0.5), 0 2px 8px rgba(0, 0, 0, 0.08) !important;
                    font-family: 'Hanken Grotesk', system-ui, sans-serif !important;
                    font-size: 14px !important;
                    line-height: 1.4 !important;
                    max-width: 280px !important;
                    min-width: 200px !important;
                    text-align: left !important;
                    animation: marva-fade-in 0.3s ease-out !important;
                    z-index: 10001 !important;
                    cursor: pointer !important;
                }

                /* arrow: a tinted body wedge over a line-coloured wedge so the
                   1px border reads through on the pointer too */
                .marva-message-preview::after {
                    content: '' !important;
                    position: absolute !important;
                    top: 100% !important;
                    left: 50% !important;
                    transform: translateX(-50%) !important;
                    border: 7px solid transparent !important;
                    border-top-color: var(--surface) !important;
                }
                .marva-message-preview::before {
                    content: '' !important;
                    position: absolute !important;
                    top: calc(100% + 1px) !important;
                    left: 50% !important;
                    transform: translateX(-50%) !important;
                    border: 7px solid transparent !important;
                    border-top-color: var(--line) !important;
                }

                .marva-message-preview-text {
                    margin-bottom: 8px !important;
                }

                .marva-message-preview-cta {
                    color: var(--gold-ink) !important;
                    font-weight: 600 !important;
                    font-size: 13px !important;
                }

                /* Animations */
                @keyframes marva-pulse {
                    0%, 100% { transform: scale(1); opacity: 1; }
                    50% { transform: scale(1.2); opacity: 0.8; }
                }

                @keyframes marva-glow {
                    0% { box-shadow: 0 0 0 0 rgba(79, 70, 229, 0.4); }
                    50% { box-shadow: 0 0 0 12px rgba(79, 70, 229, 0); }
                    100% { box-shadow: 0 0 0 0 rgba(79, 70, 229, 0); }
                }

                @keyframes marva-bounce {
                    0% { transform: translateY(0); }
                    30% { transform: translateY(-8px); }
                    50% { transform: translateY(0); }
                    70% { transform: translateY(-4px); }
                    100% { transform: translateY(0); }
                }

                @keyframes marva-fade-in {
                    0% { opacity: 0; transform: translateX(-50%) translateY(8px); }
                    100% { opacity: 1; transform: translateX(-50%) translateY(0); }
                }

                /* Modal animations */
                @keyframes marva-overlay-fade {
                    0% { opacity: 0; }
                    100% { opacity: 1; }
                }

                @keyframes marva-scale-in {
                    0% { opacity: 0; transform: scale(0.9); }
                    100% { opacity: 1; transform: scale(1); }
                }

                /* ========== TOAST NOTIFICATIONS ========== */
                .marva-toast {
                    position: fixed !important;
                    bottom: 100px !important;
                    left: 50% !important;
                    transform: translateX(-50%) !important;
                    background: rgba(0, 0, 0, 0.85) !important;
                    color: white !important;
                    padding: 12px 20px !important;
                    border-radius: 8px !important;
                    font-size: 14px !important;
                    font-weight: 500 !important;
                    display: flex !important;
                    align-items: center !important;
                    gap: 10px !important;
                    z-index: 2147483650 !important;
                    animation: marva-toast-slide-up 0.3s ease !important;
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2) !important;
                }
                .marva-toast-success {
                    background: rgba(16, 185, 129, 0.95) !important;
                }
                .marva-toast-error {
                    background: rgba(239, 68, 68, 0.95) !important;
                }
                .marva-toast-loading {
                    background: rgba(59, 130, 246, 0.95) !important;
                }
                .marva-toast-fade-out {
                    animation: marva-toast-fade-out 0.3s ease forwards !important;
                }
                .marva-toast-icon {
                    font-size: 16px !important;
                    font-weight: bold !important;
                }
                .marva-toast-spinner {
                    width: 16px !important;
                    height: 16px !important;
                    border: 2px solid rgba(255, 255, 255, 0.3) !important;
                    border-top-color: white !important;
                    border-radius: 50% !important;
                    animation: marva-toast-spin 0.8s linear infinite !important;
                }
                .marva-toast-message {
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
                }
                @keyframes marva-toast-slide-up {
                    0% { opacity: 0; transform: translateX(-50%) translateY(20px); }
                    100% { opacity: 1; transform: translateX(-50%) translateY(0); }
                }
                @keyframes marva-toast-fade-out {
                    0% { opacity: 1; transform: translateX(-50%) translateY(0); }
                    100% { opacity: 0; transform: translateX(-50%) translateY(-10px); }
                }
                @keyframes marva-toast-spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `;

const AFTER_HOURS_CSS = `
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,400;0,9..144,500;0,9..144,600;1,9..144,400&family=Hanken+Grotesk:wght@400;500;600;700&display=swap');
        .mv-dark{
          --bg:#1C1A17; --bg-2:#211E1B; --surface:#211E1B; --raise:#2A2622;
          --line:#3A352F; --line-soft:#322E29;
          --ink:#EDE6DA; --ink-soft:#A39A8C; --ink-faint:#766E62;
          --gold:#C9A86A; --gold-soft:#D8BE8C; --gold-ink:#D8BE8C;
          --sage:#8C9A7C; --sage-ink:#A6B391;
          --glow:rgba(201,168,106,.16); --gold-tint:rgba(201,168,106,.12);
          --gold-line:rgba(201,168,106,.30); --sage-tint:rgba(140,154,124,.13);
          --sage-line:rgba(140,154,124,.32);
          --orb-hi:#F0DCAE; --orb-mid:#C9A86A; --orb-lo:#6f5526;
          --glass-bg:rgba(28,26,23,.66); --glass-panel:rgba(33,30,27,.55);
        }
        .mv-light{
          --bg:#EFEAE1; --bg-2:#E9E2D5; --surface:#FCFAF6; --raise:#F3EEE4;
          --line:#E6DECF; --line-soft:#EDE7DB;
          --ink:#2A2620; --ink-soft:#6B6256; --ink-faint:#A99E8C;
          --gold:#B68A3E; --gold-soft:#C9A86A; --gold-ink:#946523;
          --sage:#6E7C5C; --sage-ink:#586647;
          --glow:rgba(182,138,62,.14); --gold-tint:rgba(182,138,62,.10);
          --gold-line:rgba(182,138,62,.28); --sage-tint:rgba(110,124,92,.10);
          --sage-line:rgba(110,124,92,.30);
          --orb-hi:#F4E2B8; --orb-mid:#C9A86A; --orb-lo:#7a5e2c;
          --glass-bg:rgba(239,234,225,.70); --glass-panel:rgba(233,226,213,.60);
        }
        .marva-afterhours{font-family:'Hanken Grotesk',system-ui,sans-serif}
        .marva-afterhours,.marva-afterhours *{box-sizing:border-box}
        .marva-afterhours .w-em{font-family:'Fraunces',serif;font-style:italic;color:var(--gold-ink)}
        /* buttons */
        .marva-afterhours.w-btn,.marva-afterhours .w-btn{display:inline-flex;align-items:center;justify-content:center;gap:7px;border-radius:99px;
          font-family:'Hanken Grotesk';font-size:12.5px;font-weight:500;cursor:pointer;border:none;padding:8px 15px;transition:.15s;white-space:nowrap;text-decoration:none}
        .marva-afterhours .w-btn.gold{background:linear-gradient(180deg,var(--gold-soft),var(--gold));color:#241d0f}
        .mv-light.marva-afterhours .w-btn.gold,.mv-light .marva-afterhours .w-btn.gold{color:#fff}
        .marva-afterhours .w-btn.ghost{background:transparent;color:var(--ink);border:1px solid var(--line)}
        .marva-afterhours .w-btn.gold.marva-card-added{background:linear-gradient(180deg,var(--sage-ink),var(--sage))}
        .marva-afterhours .w-btn:disabled{opacity:.7;cursor:default}
        /* inline spinner for the comparison "Email me this" sending state */
        .w-spin{width:14px;height:14px;border-radius:50%;flex:none;display:inline-block;vertical-align:middle;
          border:2px solid currentColor;border-right-color:transparent;animation:mvWspin .62s linear infinite}
        @keyframes mvWspin{to{transform:rotate(360deg)}}
        .marva-comparison-card-btn.busy,.marva-comparison-card-btn:disabled,
        .marva-comparison-email-btn.busy,.marva-comparison-email-btn:disabled{cursor:default !important;opacity:.95 !important;transform:none !important}
        /* card */
        .marva-afterhours.w-card{background:var(--surface);border:1px solid var(--line);border-radius:13px;overflow:hidden;width:248px;max-width:100%;color:var(--ink)}
        .marva-afterhours .w-card-img{height:130px;background:linear-gradient(135deg,var(--raise),var(--bg-2));
          display:flex;align-items:center;justify-content:center;overflow:hidden}
        .marva-afterhours .w-card-img img{width:100%;height:100%;object-fit:cover;display:block}
        .marva-afterhours .w-card-bd{padding:12px}
        .marva-afterhours .w-card-t{font-size:13.5px;font-weight:600;color:var(--ink);line-height:1.3;margin-bottom:4px;text-decoration:none;display:block}
        .marva-afterhours .w-card-v{font-size:11.5px;color:var(--ink-faint);margin-bottom:8px}
        .marva-afterhours .w-price{font-size:15px;font-weight:600;color:var(--ink);font-family:'Fraunces',serif}
        .marva-afterhours .w-price .old{font-size:12px;color:var(--ink-faint);text-decoration:line-through;margin-left:6px;font-family:'Hanken Grotesk';font-weight:400}
        .marva-afterhours .w-card .w-btn{margin-top:11px;width:100%}
        .marva-afterhours .marva-card-actions.afterhours{display:flex;flex-direction:column;gap:8px;margin-top:11px}
        .marva-afterhours .marva-card-actions.afterhours .w-btn{margin-top:0}
        /* multi-product row */
        .marva-afterhours.marva-cards-grid{display:flex;gap:10px;flex-wrap:wrap}
        .marva-afterhours.marva-cards-grid .w-card{flex:1;min-width:150px}
        /* orb avatar */
        .marva-afterhours .w-orb{border-radius:50%;flex:none;
          background:radial-gradient(circle at 30% 26%,var(--orb-hi) 0%,var(--orb-mid) 46%,var(--orb-lo) 100%);
          box-shadow:0 0 12px var(--glow);position:relative}
        .marva-afterhours .w-orb::after{content:"";position:absolute;left:50%;top:50%;width:24%;height:24%;border-radius:50%;
          transform:translate(-30%,-30%);background:radial-gradient(circle,rgba(255,247,228,.9),rgba(255,247,228,0) 70%);opacity:.7}
        /* ===== full-screen takeover ===== */
        .marva-takeover{position:fixed;inset:0;z-index:2147483000;display:none}
        .marva-takeover.open{display:block}
        .marva-takeover .w-agent{position:relative;width:100%;height:100%;display:flex;flex-direction:column;overflow:hidden;color:var(--ink);
          background:radial-gradient(135% 95% at 50% -25%, var(--gold-tint) 0%, transparent 52%), var(--glass-bg);
          -webkit-backdrop-filter:blur(22px) saturate(1.3);backdrop-filter:blur(22px) saturate(1.3)}
        .marva-takeover .wa-top{display:flex;align-items:center;gap:14px;padding:15px 22px;border-bottom:1px solid var(--line-soft);
          background:linear-gradient(180deg,var(--surface),transparent)}
        .marva-takeover .wa-id{display:flex;align-items:center;gap:11px}
        .marva-takeover .wa-id .w-orb{width:38px;height:38px}
        .marva-takeover .wa-name{font-family:'Fraunces',serif;font-size:18px;font-weight:500;line-height:1}
        .marva-takeover .wa-status{font-size:11.5px;color:var(--sage-ink);margin-top:4px;display:flex;align-items:center;gap:6px}
        .marva-takeover .wa-status .dot{width:6px;height:6px;border-radius:50%;background:var(--sage);box-shadow:0 0 6px var(--sage)}
        .marva-takeover .wa-store{margin-left:auto;font-family:'JetBrains Mono',monospace;font-size:10.5px;letter-spacing:.14em;text-transform:uppercase;color:var(--ink-faint)}
        .marva-takeover .wa-controls{display:flex;gap:8px;margin-left:auto;align-items:center}
        .marva-takeover .wa-store + .wa-controls{margin-left:18px}
        .marva-takeover .wa-ctl{width:34px;height:34px;border-radius:9px;border:1px solid var(--line);background:var(--surface);
          color:var(--ink-soft);cursor:pointer;display:flex;align-items:center;justify-content:center;transition:.14s;font-size:18px;line-height:1}
        .marva-takeover .wa-ctl:hover{border-color:var(--gold-line);color:var(--ink)}
        .marva-takeover .wa-stage{flex:1;display:flex;min-height:0;position:relative}
        .marva-takeover .wa-chat{flex:1;min-width:0;min-height:0;display:flex;flex-direction:column;align-items:center}
        .marva-takeover .wa-chat-scroll{width:100%;max-width:680px;flex:1;min-height:0;overflow-y:auto;padding:30px 24px 10px;display:flex;flex-direction:column;gap:14px}
        .marva-takeover .wa-compose{width:100%;max-width:680px;padding:12px 24px 24px}
        .marva-takeover .wa-field{display:flex;align-items:center;gap:10px;border:1px solid var(--line);background:var(--surface);border-radius:16px;padding:11px 11px 11px 17px}
        .marva-takeover .wa-field input{flex:1 !important;background:transparent !important;border:none !important;outline:none !important;box-shadow:none !important;
          -webkit-appearance:none !important;-moz-appearance:none !important;appearance:none !important;margin:0 !important;height:auto !important;
          font-size:13.5px !important;color:var(--ink) !important;font-family:'Hanken Grotesk',sans-serif !important;min-width:0 !important}
        .marva-takeover .wa-field input:focus,.marva-takeover .wa-field input:focus-visible{outline:none !important;box-shadow:none !important;border:none !important}
        .marva-takeover .wa-field input::placeholder{color:var(--ink-faint) !important}
        .marva-takeover .wa-field .send{width:36px;height:36px;border-radius:50%;flex:none;display:flex;align-items:center;justify-content:center;cursor:pointer;
          background:linear-gradient(180deg,var(--gold-soft),var(--gold));color:#241d0f;font-size:16px;border:none}
        .mv-light.marva-takeover .wa-field .send,.mv-light .marva-takeover .wa-field .send{color:#fff}
        /* conversation rows */
        .marva-afterhours .w-row{display:flex;gap:8px;align-items:flex-end;max-width:88%}
        .marva-afterhours .w-row .w-orb{width:22px;height:22px;margin-bottom:2px}
        .marva-afterhours .w-msg{font-size:14px;line-height:1.5;padding:10px 13px;border-radius:15px}
        .marva-afterhours .w-row.marva .w-msg{background:var(--surface);border:1px solid var(--line-soft);color:var(--ink);border-bottom-left-radius:5px}
        .marva-afterhours .w-row.me{align-self:flex-end;flex-direction:row-reverse}
        .marva-afterhours .w-row.me .w-msg{background:var(--gold-tint);border:1px solid var(--gold-line);color:var(--ink);border-bottom-right-radius:5px}
        .marva-afterhours .w-time{font-family:'JetBrains Mono',monospace;font-size:9.5px;color:var(--ink-faint);margin:0 30px}
        .marva-afterhours .w-quick{display:flex;flex-wrap:wrap;gap:7px;margin-left:30px}
        .marva-afterhours .w-chip{font-size:12px;color:var(--ink);background:var(--surface);border:1px solid var(--line);white-space:nowrap;border-radius:99px;padding:7px 13px;cursor:pointer;transition:.15s}
        .marva-afterhours .w-chip:hover{border-color:var(--gold-line);background:var(--gold-tint)}
        .marva-afterhours .w-typing{display:flex;gap:4px;padding:12px 14px;background:var(--surface);border:1px solid var(--line-soft);border-radius:15px;border-bottom-left-radius:5px;width:fit-content}
        .marva-afterhours .w-typing span{width:6px;height:6px;border-radius:50%;background:var(--ink-faint);animation:mvwdot 1.2s infinite}
        .marva-afterhours .w-typing span:nth-child(2){animation-delay:.15s}
        .marva-afterhours .w-typing span:nth-child(3){animation-delay:.3s}
        @keyframes mvwdot{0%,60%,100%{opacity:.3;transform:translateY(0)}30%{opacity:1;transform:translateY(-3px)}}
        .marva-afterhours .w-agent-cards{margin-left:30px;display:flex;flex-direction:column;gap:10px}
        /* launcher — the corner bubble reskinned (keeps its centered position,
           type-to-launch, and drag-and-drop) */
        .marva-launcher .marva-chat-bubble{background:var(--surface) !important;color:var(--ink) !important;
          border:1px solid var(--line) !important;border-radius:99px !important;
          box-shadow:0 14px 38px -18px rgba(0,0,0,.5),0 2px 8px rgba(0,0,0,.06) !important;
          padding:7px 8px 7px 12px !important;gap:9px !important;min-width:248px !important}
        .marva-launcher .launcher-orb{width:30px !important;height:30px !important}
        .marva-launcher .marva-bubble-input{color:var(--ink) !important;font-family:'Hanken Grotesk',sans-serif !important;font-size:14px !important}
        .marva-launcher .marva-bubble-input::placeholder{color:var(--ink-faint) !important}
        .marva-launcher .marva-drag-handle{color:var(--ink-faint) !important;opacity:.5 !important;font-size:12px !important}
        .marva-launcher .marva-bubble-send{background:linear-gradient(180deg,var(--gold-soft),var(--gold)) !important;color:#241d0f !important}
        .mv-light.marva-launcher .marva-bubble-send{color:#fff !important}
        /* ===== proactive prompt card (After Hours) — centered above the launcher ===== */
        .marva-nudge{position:fixed;left:50%;bottom:92px;z-index:2147483001;width:320px;max-width:calc(100vw - 32px);
          background:var(--surface);border:1px solid var(--line);border-radius:16px;color:var(--ink);
          box-shadow:0 18px 48px -16px rgba(0,0,0,.5),0 4px 12px rgba(0,0,0,.08);padding:15px 16px 14px;
          font-family:'Hanken Grotesk',system-ui,sans-serif;opacity:0;transform:translateX(-50%) translateY(10px);
          transition:opacity .28s ease,transform .28s cubic-bezier(.2,.7,.3,1)}
        .marva-nudge.in{opacity:1;transform:translateX(-50%) translateY(0)}
        .marva-nudge-head{display:flex;align-items:center;gap:9px;margin-bottom:9px}
        .marva-nudge-head .w-orb{width:26px;height:26px}
        .marva-nudge-name{font-family:'Fraunces',serif;font-size:15px;font-weight:500;line-height:1;color:var(--ink)}
        .marva-nudge-msg{font-size:13.5px;line-height:1.5;color:var(--ink);margin-bottom:13px}
        .marva-nudge-msg b,.marva-nudge-msg strong{font-weight:600;color:var(--gold-ink)}
        .marva-nudge-actions{display:flex;gap:8px}
        .marva-nudge-go,.marva-nudge-no{display:inline-flex;align-items:center;justify-content:center;border-radius:99px;
          font-family:'Hanken Grotesk';font-size:12.5px;font-weight:500;cursor:pointer;padding:8px 15px;transition:.15s;border:none;white-space:nowrap}
        .marva-nudge-go{background:linear-gradient(180deg,var(--gold-soft),var(--gold));color:#241d0f}
        .marva-nudge.mv-light .marva-nudge-go{color:#fff}
        .marva-nudge-no{background:transparent;color:var(--ink);border:1px solid var(--line)}
        .marva-nudge-no:hover{border-color:var(--gold-line)}
        .marva-nudge-x{position:absolute;top:9px;right:10px;width:22px;height:22px;border:none;background:transparent;
          color:var(--ink-faint);cursor:pointer;font-size:17px;line-height:1;border-radius:6px;transition:.14s}
        .marva-nudge-x:hover{color:var(--ink);background:var(--gold-tint)}
        /* ===== artifact panel (C3) ===== */
        .marva-takeover .wa-artifacts-slot:empty{display:none}
        .marva-takeover .wa-artifacts-slot{flex:none}
        .marva-takeover .wa-artifacts{width:464px;max-width:42vw;display:flex;flex-direction:column;min-height:0;height:100%;
          border-left:1px solid var(--line-soft);background:var(--glass-panel);animation:mvWaSlide .42s cubic-bezier(.2,.7,.3,1)}
        @keyframes mvWaSlide{from{transform:translateX(50px);opacity:0}to{transform:none;opacity:1}}
        .marva-takeover .wa-art-head{display:flex;align-items:center;gap:11px;padding:15px 20px;border-bottom:1px solid var(--line-soft);background:var(--surface)}
        .marva-takeover .wa-art-head .w-orb{width:26px;height:26px}
        .marva-takeover .wa-art-t{font-family:'Fraunces',serif;font-size:16px;font-weight:500;line-height:1}
        .marva-takeover .wa-art-s{font-size:11px;color:var(--ink-faint);margin-top:3px}
        .marva-takeover .wa-art-x{margin-left:auto;width:30px;height:30px;border-radius:8px;border:1px solid var(--line);background:var(--bg);
          color:var(--ink-faint);cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:16px;line-height:1}
        .marva-takeover .wa-art-x:hover{border-color:var(--gold-line);color:var(--ink)}
        .marva-takeover .wa-art-body{flex:1;overflow-y:auto;min-height:0}
        .marva-takeover .wa-remember{display:flex;align-items:center;gap:8px;flex-wrap:wrap;padding:15px 20px;border-bottom:1px solid var(--line-soft);background:var(--surface)}
        .marva-takeover .wa-rl{font-family:'JetBrains Mono',monospace;font-size:9.5px;letter-spacing:.12em;text-transform:uppercase;color:var(--gold-ink);margin-right:3px}
        .marva-takeover .wa-chip{font-size:11.5px;color:var(--ink-soft);background:var(--bg);border:1px solid var(--line);border-radius:99px;padding:5px 11px}
        .marva-takeover .wa-activity{padding:16px 20px 4px;display:flex;flex-direction:column;gap:11px}
        .marva-takeover .wa-act{display:flex;align-items:flex-start;gap:11px;font-size:13px;color:var(--ink-soft);line-height:1.4}
        .marva-takeover .wa-act .mk{width:18px;height:18px;border-radius:50%;flex:none;margin-top:1px;display:flex;align-items:center;justify-content:center}
        .marva-takeover .wa-act .mk.done{background:var(--sage-tint);border:1px solid var(--sage-line);color:var(--sage-ink);font-size:11px}
        .marva-takeover .wa-act b{color:var(--ink);font-weight:600}
        .marva-takeover .wa-act .em{font-family:'Fraunces',serif;font-style:italic;color:var(--gold-ink)}
        .marva-takeover .wa-items{padding:14px 20px 22px;display:flex;gap:13px;flex-wrap:wrap}
        .marva-takeover .wa-prod{flex:1;min-width:170px;background:var(--surface);border:1px solid var(--line);border-radius:14px;overflow:hidden;position:relative;display:flex;flex-direction:column}
        .marva-takeover .wa-prod.hl{border-color:var(--gold-line);box-shadow:0 0 0 1px var(--gold-line),0 20px 44px -30px var(--glow)}
        .marva-takeover .wa-prod .pim{height:138px;background:linear-gradient(135deg,var(--raise),var(--bg-2));display:flex;align-items:center;justify-content:center;overflow:hidden}
        .marva-takeover .wa-prod .pim img{width:100%;height:100%;object-fit:cover}
        .marva-takeover .wa-prod .pbd{padding:13px 14px 15px;display:flex;flex-direction:column;flex:1}
        .marva-takeover .wa-prod .ptag{font-size:9px;letter-spacing:.09em;text-transform:uppercase;font-weight:600;margin-bottom:7px}
        .marva-takeover .wa-prod.hl .ptag{color:var(--gold-ink)}
        .marva-takeover .wa-prod .ptag.mute{color:var(--ink-faint)}
        .marva-takeover .wa-prod .pname{font-size:14px;font-weight:600;line-height:1.3;color:var(--ink);text-decoration:none;display:block}
        .marva-takeover .wa-prod .pvar{font-size:11.5px;color:var(--ink-faint);margin-top:3px}
        .marva-takeover .wa-prod .pprice{font-family:'Fraunces',serif;font-size:16px;font-weight:600;margin-top:8px;color:var(--ink)}
        .marva-takeover .wa-prod .pprice .old{font-size:12px;color:var(--ink-faint);text-decoration:line-through;margin-left:6px;font-family:'Hanken Grotesk';font-weight:400}
        .marva-takeover .wa-prod .pbtn{margin-top:auto;padding-top:12px;display:flex;flex-direction:column;gap:8px}
        .marva-takeover .wa-prod .pbtn .w-btn{width:100%}
        .marva-takeover .wa-cartlist .w-btn{justify-content:center}
        /* (the old .wa-cap capture panel is gone — capture renders through
           ContactCaptureManager now, styled by the .marva-cc-* block below) */
        .marva-takeover .w-fld{width:100%;height:40px;padding:0 13px;border-radius:11px;background:var(--surface);border:1px solid var(--line);color:var(--ink);font-size:13px;font-family:'Hanken Grotesk';margin-bottom:9px}
        .marva-takeover .w-fld::placeholder{color:var(--ink-faint)}
        .marva-takeover .w-priv{font-size:10.5px;color:var(--ink-faint);text-align:center;margin-top:9px}
        /* cart panel */
        .marva-takeover .wa-cartlist{padding:6px 20px 22px}
        .marva-takeover .wa-cartlist .ci{display:flex;gap:9px;padding:9px 0;border-bottom:1px solid var(--line-soft);align-items:center}
        .marva-takeover .wa-cartlist .ci .th{width:42px;height:42px;border-radius:7px;flex:none;background:linear-gradient(135deg,var(--raise),var(--bg-2));overflow:hidden}
        .marva-takeover .wa-cartlist .ci .th img{width:100%;height:100%;object-fit:cover}
        .marva-takeover .wa-cartlist .ci .cm{flex:1;min-width:0}
        .marva-takeover .wa-cartlist .ci .nm{font-size:12px;font-weight:500;color:var(--ink);line-height:1.3;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
        .marva-takeover .wa-cartlist .ci .q{font-size:11px;color:var(--ink-faint);margin-top:2px}
        .marva-takeover .wa-cartlist .ci .pr{margin-left:auto;font-size:12.5px;font-weight:600;color:var(--ink);font-family:'Fraunces',serif}
        .marva-takeover .wa-cartlist .sub{display:flex;justify-content:space-between;align-items:baseline;padding-top:11px}
        .marva-takeover .wa-cartlist .sub .l{font-size:13px;font-weight:600;color:var(--ink)}
        .marva-takeover .wa-cartlist .sub .v{font-family:'Fraunces',serif;font-size:16px;font-weight:600;color:var(--ink)}
        /* inline "opened" cue in the chat */
        .marva-afterhours .wa-opened{align-self:flex-start;margin-left:30px;display:inline-flex;align-items:center;gap:8px;font-size:12px;
          color:var(--gold-ink);background:var(--gold-tint);border:1px solid var(--gold-line);border-radius:99px;padding:6px 13px}
        .marva-afterhours .wa-opened .sp{width:11px;height:11px;border-radius:50%;flex:none;background:radial-gradient(circle at 30% 30%,var(--orb-hi),var(--orb-lo));box-shadow:0 0 5px var(--glow)}
        /* ===== contact capture card (ContactCaptureManager — chat + modal) ===== */
        /* createFormHTML emits .marva-contact-card; the .marva-cc-card half of
           this selector has never matched anything, so the card carried no
           surface, border or shadow on the modal/chat paths. Both kept. */
        .marva-afterhours .marva-cc-card,.marva-cc-card.marva-afterhours,
        .marva-afterhours .marva-contact-card,.marva-contact-card.marva-afterhours{background:var(--surface);border:1px solid var(--line);border-radius:16px;
          padding:18px;margin:12px 0;color:var(--ink);font-family:'Hanken Grotesk',system-ui,sans-serif;
          box-shadow:0 18px 48px -28px var(--glow),0 2px 8px rgba(0,0,0,.08)}
        .marva-afterhours .marva-cc-head{display:flex;align-items:center;gap:11px;margin-bottom:16px;padding-bottom:14px;border-bottom:1px solid var(--line-soft)}
        .marva-afterhours .marva-cc-head .w-orb{width:32px;height:32px}
        .marva-afterhours .marva-cc-title{font-family:'Fraunces',serif;font-size:15px;font-weight:500;color:var(--ink);line-height:1.1}
        .marva-afterhours .marva-cc-sub{font-size:12px;color:var(--ink-soft);margin-top:3px;line-height:1.4}
        .marva-afterhours .marva-cc-fields{display:flex;flex-direction:column;gap:9px}
        .marva-afterhours .marva-cc-email,.marva-afterhours .marva-cc-phone{width:100%;height:42px;padding:0 13px;border-radius:11px;
          background:var(--bg);border:1px solid var(--line);color:var(--ink);font-size:14px;font-family:'Hanken Grotesk';outline:none;box-sizing:border-box;
          transition:border-color .15s,box-shadow .15s}
        .marva-afterhours .marva-cc-email::placeholder,.marva-afterhours .marva-cc-phone::placeholder{color:var(--ink-faint)}
        .marva-afterhours .marva-cc-email:focus,.marva-afterhours .marva-cc-phone:focus{border-color:var(--gold-line);box-shadow:0 0 0 3px var(--gold-tint)}
        .marva-afterhours .marva-cc-pref-wrap{margin-top:14px}
        .marva-afterhours .marva-cc-pref-label{font-size:11px;color:var(--ink-faint);display:block;margin-bottom:7px;font-weight:500}
        .marva-afterhours .marva-cc-pref-row{display:flex;gap:7px}
        .marva-afterhours .marva-cc-pref{flex:1;display:flex;align-items:center;justify-content:center;gap:6px;padding:10px 8px;
          border:1px solid var(--line);border-radius:11px;font-size:12.5px;color:var(--ink-soft);cursor:pointer;background:var(--bg);transition:.15s}
        .marva-afterhours .marva-cc-pref:hover{border-color:var(--gold-line)}
        .marva-afterhours .marva-cc-pref:has(input:checked){border-color:var(--gold-line);background:var(--gold-tint);color:var(--gold-ink);font-weight:600}
        .marva-afterhours .marva-cc-pref input{accent-color:var(--gold);margin:0}
        .marva-afterhours .marva-cc-consent-box{margin-top:14px;padding:10px 12px;background:var(--bg);border:1px solid var(--line-soft);border-radius:11px}
        .marva-afterhours .marva-cc-consent-label{display:flex;align-items:flex-start;gap:8px;font-size:12px;color:var(--ink-soft);cursor:pointer;line-height:1.45}
        .marva-afterhours .marva-cc-consent{margin-top:2px;accent-color:var(--gold)}
        .marva-afterhours .marva-cc-consent-label a{color:var(--gold-ink);text-decoration:none}
        .marva-afterhours .marva-cc-error{display:none;padding:10px 12px;border-radius:11px;margin-top:12px;font-size:13px;
          background:rgba(176,74,52,.12);border:1px solid rgba(176,74,52,.30);color:#c2603f}
        .marva-afterhours .marva-cc-submit-btn{width:100%;margin-top:16px;border:none;border-radius:99px;padding:13px;
          font-family:'Hanken Grotesk';font-size:14px;font-weight:600;cursor:pointer;transition:.15s;
          background:linear-gradient(180deg,var(--gold-soft),var(--gold));color:#241d0f}
        .mv-light.marva-afterhours .marva-cc-submit-btn,.mv-light .marva-afterhours .marva-cc-submit-btn{color:#fff}
        .marva-afterhours .marva-cc-submit-btn:hover{transform:translateY(-1px)}
        .marva-afterhours .marva-cc-submit-btn:disabled{opacity:.7;cursor:default;transform:none}
        .marva-afterhours .marva-cc-skip-btn{width:100%;margin-top:8px;background:transparent;color:var(--ink-soft);border:none;padding:10px;font-size:13px;cursor:pointer}
        .marva-afterhours .marva-cc-skip-btn:hover{color:var(--ink)}
        .marva-afterhours .marva-cc-priv{font-size:10.5px;color:var(--ink-faint);text-align:center;margin-top:10px;display:flex;align-items:center;justify-content:center;gap:5px}
        /* --- the value exchange: what this address buys, and what it doesn't --- */
        .marva-afterhours .marva-cc-promise{margin:0 0 16px;padding:12px 13px;border-radius:12px;
          background:var(--gold-tint);border:1px solid var(--gold-line)}
        .marva-afterhours .marva-cc-promise-line{font-size:13px;color:var(--ink);line-height:1.5}
        .marva-afterhours .marva-cc-promise-line b{font-weight:600;color:var(--gold-ink)}
        .marva-afterhours .marva-cc-promise-limit{font-size:11px;color:var(--ink-faint);margin-top:6px}

        /* --- capture as a pinned artifact: it fills the panel width, sits above
               whatever picks/cart is showing, and collapses without answering --- */
        .marva-takeover .wa-art-pinned{flex:none;border-bottom:1px solid var(--line-soft)}
        .marva-takeover .wa-art-pinned .marva-contact-card{margin:0;border:none;border-radius:0;box-shadow:none;
          background:var(--surface);padding:16px 20px 18px}
        .marva-takeover .wa-art-main{flex:1;display:flex;flex-direction:column;min-height:0;overflow:hidden}
        .marva-afterhours .marva-cc-collapse{margin-left:auto;width:30px;height:30px;border-radius:8px;flex:none;
          border:1px solid var(--line);background:var(--bg);color:var(--ink-faint);cursor:pointer;
          display:flex;align-items:center;justify-content:center;font-size:16px;line-height:1}
        .marva-afterhours .marva-cc-collapse:hover{border-color:var(--gold-line);color:var(--ink)}

        /* --- launcher badge: Marva is still holding a spot (no card, no cooldown) --- */
        .marva-launcher-badge{position:absolute;bottom:calc(100% + 8px);left:0;right:0;padding:7px 12px;border-radius:99px;
          background:var(--surface);border:1px solid var(--gold-line);color:var(--ink-soft);font-size:11.5px;
          font-family:'Hanken Grotesk',system-ui,sans-serif;text-align:center;cursor:pointer;white-space:nowrap;
          overflow:hidden;text-overflow:ellipsis;box-shadow:0 8px 24px -16px rgba(0,0,0,.4)}

        /* contact modal overlay */
        .marva-contact-modal-overlay{background:rgba(20,16,12,.46) !important;backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px)}
        /* on small screens, stack the panel under the chat */
        @media (max-width:760px){
          /* --- launcher docks full-width to the bottom edge; drag is disabled
                 (dragging fights the page scroll on touch) --- */
          .marva-chat{left:12px !important;right:12px !important;bottom:calc(14px + env(safe-area-inset-bottom)) !important;transform:none !important}
          .marva-chat.dragged,.marva-chat.dragging{left:12px !important;right:12px !important;transform:none !important}
          .marva-chat-bubble{width:100% !important;min-width:0 !important}
          /* tighter, low-bias shadow on touch: the design's big downward shadow
             dips into the translucent Safari toolbar and gets cut with a hard
             line. A soft ambient shadow has no crisp edge to clip. */
          .marva-launcher .marva-chat-bubble{box-shadow:0 6px 22px -10px rgba(0,0,0,.30) !important}
          .marva-launcher .marva-drag-handle,.marva-drag-handle{display:none !important}

          /* --- the pinned capture cannot share the sheet with picks on a phone,
                 so it docks above the composer instead: one line by default,
                 tap to expand the form in place. The node is MOVED here, never
                 rebuilt, so anything typed survives the swap. --- */
          .marva-takeover .wa-cap-dock{flex:none;margin:0 12px 8px;border:1px solid var(--gold-line);border-radius:14px;
            background:var(--surface);overflow:hidden;box-shadow:0 10px 30px -22px rgba(0,0,0,.5)}
          .marva-takeover .wa-cap-dock .marva-contact-card{margin:0;border:none;border-radius:0;box-shadow:none;padding:14px 15px 16px}
          .marva-takeover .wa-cap-dock.collapsed{cursor:pointer}
          .marva-takeover .wa-cap-dock.collapsed .marva-cc-head{margin-bottom:0;padding-bottom:0;border-bottom:none}
          .marva-takeover .wa-cap-dock.collapsed .marva-cc-promise,
          .marva-takeover .wa-cap-dock.collapsed .marva-cc-fields,
          .marva-takeover .wa-cap-dock.collapsed .marva-cc-pref-wrap,
          .marva-takeover .wa-cap-dock.collapsed .marva-cc-consent-box,
          .marva-takeover .wa-cap-dock.collapsed .marva-cc-error,
          .marva-takeover .wa-cap-dock.collapsed .marva-cc-submit-btn,
          .marva-takeover .wa-cap-dock.collapsed .marva-cc-skip-btn{display:none}
          .marva-takeover .wa-cap-dock .marva-contact-card{padding:12px 14px}

          /* --- agent takeover: single column; the chat owns the height --- */
          .marva-takeover .wa-stage{flex-direction:column}

          /* the artifact panel detaches from the flex flow and rises as a
             draggable BOTTOM SHEET over the chat (the slot becomes a tap-to-
             dismiss scrim anchored to the takeover; empty slot stays hidden).
             It opens at a peek height; the grab handle drags it up to expand or
             down to dismiss (wired in wireSheetDrag). */
          .marva-takeover .wa-artifacts-slot{position:absolute;inset:0;z-index:6;display:flex;
            align-items:flex-end;background:rgba(20,16,12,.42);animation:mvScrim .2s ease}
          /* entry is a one-shot TRANSITION (translateY 100%→0 via the .in class
             added on mount), not a keyframe — a keyframe re-runs every time the
             .dragging class is toggled off (on every tap), which caused a flicker
             on expand and on close. */
          .marva-takeover .wa-artifacts{width:100%;max-width:100%;flex:none;height:58%;
            border-left:none;border-top:1px solid var(--line-soft);border-radius:20px 20px 0 0;
            box-shadow:0 -20px 44px -30px var(--glow);transform:translateY(100%);
            transition:height .32s cubic-bezier(.2,.7,.3,1),transform .34s cubic-bezier(.2,.7,.3,1);will-change:transform,height}
          .marva-takeover .wa-artifacts.in{transform:none}
          .marva-takeover .wa-artifacts.expanded{height:90%}
          .marva-takeover .wa-artifacts.dragging{transition:none}
          .marva-takeover .wa-art-head{position:relative;border-radius:20px 20px 0 0;padding-top:20px;
            touch-action:none;cursor:grab;user-select:none;-webkit-user-select:none}
          .marva-takeover .wa-art-head::before{content:"";position:absolute;top:8px;left:50%;transform:translateX(-50%);
            width:38px;height:5px;border-radius:99px;background:var(--line)}
          .marva-takeover .wa-items{flex-direction:column}

          /* --- reaction icons: no hover on touch, so keep them visible --- */
          .marva-reaction-container{opacity:1 !important}
        }
        @keyframes mvScrim{from{opacity:0}to{opacity:1}}

        /* ===== iOS / touch keyboard hardening =====
           Three real-phone bugs (none visible on desktop): Safari auto-zoom on
           focus of a <16px field; the compose bar drifting to mid-screen when
           the keyboard opens; and the storefront bleeding through the open chat.
           Scoped to (pointer:coarse) so the desktop widget is untouched. CSS
           handles the 16px zoom-guard + an OPAQUE full-bleed surface; the
           keyboard-tracking half is wired in JS (ensureMobileViewport adds the
           host viewport meta; pinTakeoverToViewport pins to visualViewport for
           iOS<17). */
        @media (pointer: coarse){
          /* 1 — every real field is >=16px, so focus never triggers a zoom */
          .marva-bubble-input,
          .marva-launcher .marva-bubble-input,
          .marva-takeover .wa-field input,
          .marva-takeover .wa-field textarea,
          .marva-afterhours .marva-cc-email,
          .marva-afterhours .marva-cc-phone,
          .marva-afterhours .w-fld{font-size:16px !important;line-height:1.35 !important}

          /* 2 + 3 — the takeover owns the dynamic viewport and is OPAQUE: drop
             the translucent glass + backdrop blur that let the storefront show
             through, and clip its own scroll so momentum can't reach the page */
          /* the takeover is a full-screen OPAQUE backdrop — inset:0 (large
             viewport) covers the whole screen, including behind the Safari
             toolbar and the keyboard, so the storefront can never show through.
             Do NOT shrink it to svh/dvh (that left the seam at the toolbar). */
          .marva-takeover{background:var(--bg)}
          /* the agent surface (header + chat + composer) is sized to the VISIBLE
             area so the composer rides above the toolbar/keyboard; whatever sits
             below it is the opaque backdrop, never the store. JS (pinAgentToViewport)
             sets the exact height; 100svh is the no-JS fallback that clears the toolbar. */
          .marva-takeover .w-agent{height:100svh;overscroll-behavior:contain;will-change:transform,height;
            background:radial-gradient(135% 95% at 50% -25%, var(--gold-tint) 0%, transparent 52%), var(--bg);
            -webkit-backdrop-filter:none;backdrop-filter:none}
          .marva-takeover .wa-chat-scroll{-webkit-overflow-scrolling:touch;overscroll-behavior:contain}

          /* compose pinned to the bottom of the surface, opaque, above the home indicator */
          .marva-takeover .wa-compose{position:sticky;bottom:0;z-index:2;background:var(--bg);
            padding-bottom:calc(20px + env(safe-area-inset-bottom))}
        }
      `;

/**
 * The merchant on-site theme (server-resolved by `@marva/shared/theme-resolver`) as ONE CSS rule
 * scoped onto every Marva surface — the After Hours widget scopes and the suitability ask cards.
 * Pure, so the widget (`MarvaChat.applyMerchantTheme`) and the merchant app's chat preview
 * (MAR-391) apply a theme with the same code. Unsafe keys and values are dropped; a missing or
 * empty theme yields '' (the After Hours look stays).
 */
function merchantThemeCss(theme) {
  if (!theme || typeof theme !== 'object') return '';
  const decls = Object.entries(theme)
    .filter(([k, v]) => /^--[\w-]+$/.test(k) && typeof v === 'string')
    .map(([k, v]) => `${k}:${v.replace(/[;{}]/g, '')}`)
    .join(';');
  if (!decls) return '';
  return `.marva-afterhours,.mv-dark,.mv-light,.mv-ask,.mv-ask-confirmed,.mv-ask-trace,.marva-nudge{${decls}}`;
}

module.exports = { CHAT_WIDGET_CSS, AFTER_HOURS_CSS, merchantThemeCss };
